/**
 * Shipped Evidence API
 *
 * Functions for fetching AI-detected hints that a work item may already
 * be covered by existing git activity (commits/PRs).
 */

import { api } from "./client";

export interface ShippedEvidencePullRequest {
  number: number;
  title: string;
  url: string;
  merged_at: string | null;
}

export interface ShippedEvidence {
  id: string;
  work_item_id: string;
  analysis_id: string;
  confidence: "high" | "medium";
  match_kind: "explicit_reference" | "semantic";
  commit_shas: string[];
  pull_requests: ShippedEvidencePullRequest[];
  rationale: string | null;
  detected_at: string;
}

export async function fetchShippedEvidence(
  workItemId: string,
): Promise<ShippedEvidence | null> {
  const response = await api.get<{ evidence: ShippedEvidence | null }>(
    `/work-items/${workItemId}/shipped-evidence`,
  );
  return response.evidence ?? null;
}
